import React from 'react';
import { Box, Typography, Modal, Button } from '@mui/material';
import SoundCloudPlayer from './SoundCloudPlayer';

const getSoundCloudEmbedUrl = (url) => {
  if (!url) return "";
  return `https://w.soundcloud.com/player/?url=${encodeURIComponent(
    url
  )}&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true`;
};

const AudioModal = ({ open, onClose, title, audioUrl, content, excerpt }) => (
  <Modal
    open={open}
    onClose={onClose}
    sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}
  >
    <Box sx={{ 
      bgcolor: 'background.paper', 
      borderRadius: 3, 
      boxShadow: 8, 
      p: { xs: 3, sm: 5 }, 
      minWidth: { xs: '90vw', sm: 500, md: 700 }, 
      maxWidth: '95vw',
      maxHeight: '90vh',
      overflow: 'auto',
      display: 'grid', 
      gridTemplateRows: 'auto auto 1fr auto', 
      rowGap: 2 
    }}>
      <Typography variant="h5" fontWeight={700} color="primary" sx={{ textAlign: 'center', mb: 1 }}>
        Listen: {title}
      </Typography>
      
      {/* SoundCloud Player */}
      {audioUrl && (
        <Box sx={{ width: '100%', mb: 2 }}>
           <iframe
                        width="100%"
                        height="166"
                        scrolling="no"
                        frameBorder="no"
                        allow="autoplay"
                        src={getSoundCloudEmbedUrl(audioUrl)}
                      ></iframe>
        </Box>
      )}
      
      {excerpt && (
        <Typography variant="body2" color="text.secondary" paragraph>
          {excerpt}
        </Typography>
      )}
      
      {content && (
        <Typography variant="body1" sx={{ 
          whiteSpace: 'pre-wrap',
          lineHeight: 1.6,
          fontSize: '1.1rem'
        }}>
          {content}
        </Typography>
      )}
      
      <Button 
        variant="contained" 
        color="primary" 
        sx={{ borderRadius: 999, fontWeight: 600 }} 
        onClick={onClose}
      >
        Close
      </Button>
    </Box>
  </Modal>
);

export default AudioModal; 